/**
 * LA CUENTA DEL PANEL DEL DUENO AL CERRAR LA FICHA (ONB-CUENTA-PANEL-T1, contrato de A #33419, OK de P).
 *
 * POST /api/v1/onboarding/cuenta-panel {token, correo, clave} -> 204 CUENTA_CREADA; errores problem+json con code. La
 * regla es la de A, repetida aqui para no gastar el viaje: correo con formato, clave de 10 o mas y distinta del correo.
 * El panel NO decide si la cuenta existe: eso lo dice el 409 de A.
 *
 * La clave nunca se guarda: no entra a borrador, captured ni responses; solo viaja en este POST.
 *
 * Sin DOM: lo prueba scripts/check-onboard-cuenta-panel.mjs.
 *
 * @module application/onboarding/cuentaPanel
 */

// La regla ENTERA de A, copiada de OnboardingCuentaPanelService.MotivoDeRechazo (nexo-api 620), no un pedazo: Q #33441
// cazo que faltaban los 4 caracteres distintos ('x' x128 pasaba aqui y la API la rechaza).
export const CLAVE_MINIMA = 10;
export const CLAVE_MAXIMA = 128;
export const CLAVE_DISTINTOS = 4;
export const CORREO_MAXIMO = 254;
const CORREO = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

/** Lo que el panel revisa antes del viaje. Devuelve [] si se puede enviar. */
export function erroresDeLaCuenta({ correo, clave, repetida }) {
  const c = String(correo || '').trim();
  const k = String(clave || '');
  const errores = [];
  if (!c || c.length > CORREO_MAXIMO || !CORREO.test(c)) errores.push('Escribe un correo valido, por ejemplo nombre@correo.com.');
  if (k.length < CLAVE_MINIMA) errores.push(`La clave necesita al menos ${CLAVE_MINIMA} caracteres.`);
  else if (k.length > CLAVE_MAXIMA) errores.push(`La clave puede tener hasta ${CLAVE_MAXIMA} caracteres.`);
  else if (k.trim().toLowerCase() === c.toLowerCase()) errores.push('La clave no puede ser igual al correo.');
  else if (new Set(k).size < CLAVE_DISTINTOS) errores.push(`Usa una clave mas variada: al menos ${CLAVE_DISTINTOS} caracteres distintos.`);
  if (k !== String(repetida || '')) errores.push('Las dos claves no son iguales.');
  return errores;
}

/** Cada code de A en una frase para el dueno; uno que no se conoce no se inventa. */
export const MENSAJES_CUENTA = {
  CUENTA_CREADA: 'Listo: tu cuenta del panel quedo creada. Ya puedes entrar con tu correo y tu clave.',
  CUENTA_YA_EXISTE: 'Tu negocio ya tiene una cuenta del panel. Entra con ella; si no recuerdas la clave, pidela a Nexo.',
  CORREO_EN_USO: 'Ese correo ya tiene una cuenta en Nexo. Usa otro correo.',
  // SEC-ONBOARDING-DOMINIO-T1 (nexo-api 676): el alta publica no acepta correos de Nexo; reintentar no sirve.
  CORREO_RESERVADO: 'Ese correo es de Nexo y no sirve para la cuenta de tu negocio. Usa el correo del negocio.',
  CORREO_FORMATO: 'El correo no tiene un formato valido.',
  CLAVE_DEBIL: `La clave necesita al menos ${CLAVE_MINIMA} caracteres variados y no puede ser el correo.`,
  DEMASIADOS_INTENTOS: 'Hubo demasiados intentos. Espera unos minutos y vuelve a intentarlo.',
  SESION_SIN_COMPLETAR: 'Primero termina la ficha de tu negocio.',
  SIN_CONSENTIMIENTO_DE_DATOS: 'Para crear la cuenta necesitamos tu autorizacion de datos de la ficha.',
  TOKEN_NO_EXISTE: 'Este enlace ya no sirve. Pide uno nuevo a Nexo.',
  TOKEN_REQUERIDO: 'Este enlace ya no sirve. Pide uno nuevo a Nexo.',
  // 410 (nexo-api 723, Ares #40212): el enlace vence a los 14 dias de creado; reintentar no sirve.
  ENLACE_VENCIDO: 'Este enlace ya no sirve. Pide uno nuevo a Nexo.'
};

/** La respuesta del POST ({status, cuerpo}) en {ok, code, mensaje}. */
export function leerRespuestaDeCuenta(r) {
  if (!r) return { ok: false, code: 'SIN_RED', mensaje: 'No pudimos hablar con Nexo. Revisa tu conexion e intenta otra vez.' };
  if (r.status === 204 || r.status === 200) return { ok: true, code: 'CUENTA_CREADA', mensaje: MENSAJES_CUENTA.CUENTA_CREADA };
  const code = String(r.cuerpo?.code || r.cuerpo?.Code || '').trim();
  return { ok: false, code: code || 'ERROR', mensaje: MENSAJES_CUENTA[code] || 'No pudimos crear la cuenta ahora. Intenta en un rato.' };
}
